
















































































import vueSlider from 'vue-slider-component'
import openApp from '@ivy/fts/openApp'
import playList from './list.vue'
import { Component, Vue, Prop } from 'vue-property-decorator'
import showDiv, { closeAll } from '@ivy/fts/showDiv'
import showApp from '../../components/showApp.vue'
import { isWeixin } from '@ivy/fts/utils'

@Component({
  components: { vueSlider, playList }
})

export default class ControlBox extends Vue {
  @Prop() audio: any
  @Prop() audioObj: any
  @Prop() curValue: any
  @Prop() albums: any
  @Prop() album: any
  @Prop() index: any
  @Prop() currentTime: any
  @Prop() qr: any
  hideAudio: any = [9513, 9518, 9522, 9515, 9519, 9512, 9511, 9520, 9521, 9517, 9516, 9514, 9510, 9507, 9509, 9506, 9508, 9527, 9523, 9524, 9528, 9526, 9537, 9536, 9534, 9532, 9530, 9531, 9533, 9529, 9525, 9567, 9566, 9568, 9563, 9565, 9564, 9560, 9561, 9562, 9556, 9559, 9558, 9554, 9557, 9555, 9583, 9581, 9582, 9580, 9577, 9579, 9576, 9578, 9574, 9570, 9571, 9572, 9569, 9573, 9575, 9545, 9546, 9544, 9547, 9542, 9543, 9541, 9539, 9540, 9538, 9548, 9549, 9550, 9551, 9552, 9553, 9535]
  listIsShow: boolean = false
  isShow: boolean = true
  playing: boolean = false // 播放状态
  slider: any = { // 控制进度条部分
    height: 2,
    dotSize: 12,
    bgStyle: {
      backgroundColor: "#e6e6e6",
      height: "0.1rem",
    },
    processStyle: {
      backgroundColor: "#00B097",
    },
    sliderStyle: {
      backgroundColor: "#00B097",
      boxShadow: "none",
    }
  }
  isWeixin: boolean = isWeixin()
  mounted() {
    console.log('-----', this.audio)
    if (this.$route.query.from === 'qr' && this.hideAudio.includes(+this.audio.id)) {
      this.isShow = false
    }
  }
  toAlbum() {
    // this.$router.push(`/albumInfo/${this.album.id}`)
    let query = this.$route.query
    this.$router.push({path: `/albumInfo/${this.album.id}`, query})
  }
  get playcount() {
    let f = this.album.play_count > 9999
    return f ? `${(this.album.play_count / 10000).toFixed(1)}万` : this.album.play_count
  }
  async beforeDestroy() {
    await this.pause()
  }
  async playCurrent(index) {
    if (!this.qr && this.albums[index].has_access === 0 && this.albums[index].access_type === 'sale' && !this.albums[index].listen) {
      this.$Toast('该音频为付费音频')
      return
    } else if (!this.qr && this.albums[index].has_access === 0 && (this.albums[index].access_type === 'vip' || this.albums[index].access_type === 'sale_vip') && !this.albums[index].listen) {
      this.$Toast('该音频需开通会员')
      return
    } else {
      await this.$emit('playCurrent', index)
    }
  }
  async play(pos) {
    if (this.audio.has_access === 1 || this.audio.listen === 1) {
      this.playing = true
      await this.audioObj.play(pos === undefined ? this.currentTime : pos)
    } else if (this.audio.has_access === 0 && this.audio.access_type === 'sale') {
      this.$Toast('当前为付费音频，请购买音频')
    } else if (this.audio.has_access === 0 && ['sale_vip', 'vip'].includes(this.audio.access_type)) {
      this.$Toast('当前为会员音频，请开通会员')
    }
  }
  async pause() {
    this.playing = false
    await this.audioObj.pause()
  }
  async changeSlider(event) {
    let pos = Math.floor(this.audio.duration / (100 / event))
    this.playing = true
    await this.audioObj.play(pos)
  }
  async toApp() {
    showDiv(showApp, {
      closeAll
    })
  }
}
